import "amfe-flexible";

const initRemOption = () => {
  const designWidth = 1280; // 分屏点
  const maxBaseSize = 14; // 大于 1280px 的根字体大小
  const minBaseSize = 12; // 小于等于 1280px 的根字体大小

  const html = document.documentElement;
  const screenWidth = html.clientWidth;
  html.style.setProperty("font-family", "Manrope", "important");
  if (screenWidth > designWidth) {
    html.style.setProperty("font-size", `${maxBaseSize}px`, "important");
  } else {
    html.style.setProperty("font-size", `${minBaseSize}px`, "important");
  }
  console.log(html.style.fontSize);
};

// 初始化字体大小
initRemOption();

// 窗口变化时重新设置
window.addEventListener("resize", initRemOption);
